<template>
  <div>
    <div class="grey-box-container" v-if="loading">
      <InlineSpinner />
    </div>
    <div class="grey-box-container" v-else>

      <div class="brokerContainer" v-if="type === 'medium'">
        <p>AGENT CONTACTS</p>
        <div>
          <div class="brokerPhoto"><img :src="brokerPhoto" class="user-avatar" /></div>
          <div class="brokerInfo">
            <div style="margin-bottom:0.25rem; font-size: 1.2rem;">{{ brokerUserProfile.firstName }} {{ brokerUserProfile.lastName }}</div>
            <div v-if="brokerUserProfile.title">Title: {{ brokerUserProfile.title }}</div>
            <div v-if="brokerUserProfile.dreNumber">DRE License Number: {{ brokerUserProfile.dreNumber }}</div>
            <div v-if="brokerUserProfile.phone">Cell Phone Number: {{ brokerUserProfile.phone }}</div>
            <div v-if="brokerUserProfile.officePhone">Office Phone Number: {{ brokerUserProfile.officePhone }}</div>
            <!--
            <div v-if="brokerUserProfile.fax">Fax Phone Number: {{ brokerUserProfile.fax }}</div>
            -->
            <div>Email: <a :href="'mailto:' + brokerUserProfile.email">{{ brokerUserProfile.email }}</a></div>
          </div>
        </div>
        <div>
          <pre>
           <p></p>
          </pre>
          <!-- <div class="brokerLogo"><img :src="tenantLogoUrl(tenantProfile)" /></div> -->
          <ul v-for="item in delegatedAgentProfiles" :key="item.userId">
            <div>
              <br>
              <div v-if="item.avatarUrl" class="brokerPhoto"><img :src="item.avatarUrl" class="user-avatar"/></div>
              <div v-else class="brokerPhoto"><img :src="brokerPhoto" class="user-avatar" /></div>
              <div class="brokerInfo">
                <strong>Name: {{ item.firstName }} {{ item.lastName }}</strong><br/>
                <div v-if="item.title">Title: {{ item.title }}</div>
                <div v-if="item.phoneNumber">Cell Phone Number: {{ item.phoneNumber }}</div>
                <div v-if="item.officePhone">Office Phone Number: {{ item.officePhone }}</div>
                <div>Email: <a :href="'mailto:' + item.email"><small>{{ item.email | truncate(40) }}</small></a></div><br/>
              </div>
              <br>
            </div>
          </ul>
        </div>
      </div>

      <div class="brokerContainer" v-if="type === 'small'">
        <div class="brokerPhoto"><img :src="brokerPhoto" class="user-avatar" /></div>
        <div class="brokerInfo">
          <strong>{{ brokerUserProfile.firstName }} {{ brokerUserProfile.lastName }}</strong><br/>
          <div v-if="brokerUserProfile.title">Title: {{ brokerUserProfile.title }}</div>
          <div v-if="brokerUserProfile.phone">Cell Phone Number: {{ brokerUserProfile.phone }}</div>
          <div v-if="brokerUserProfile.officePhone">Office Phone Number: {{ brokerUserProfile.officePhone }}</div>
          <div>Email: <a :href="'mailto:' + brokerUserProfile.email"><small>{{ brokerUserProfile.email | truncate(40) }}</small></a></div><br/>
        </div>
      </div>

      <div class="brokerContainer" v-if="type === 'message'">
        <div class="message list-bullets"><vue-markdown :source="initialAuction.metadata.messageToBuyer" /></div>
        <div class="brokerPhoto"><img :src="brokerPhoto" class="user-avatar" /></div>
        <div class="brokerInfo">
          <strong>{{ brokerUserProfile.firstName }} {{ brokerUserProfile.lastName }}</strong><br/>
          <div v-if="brokerUserProfile.title">Title: {{ brokerUserProfile.title }}</div>
          <div v-if="brokerUserProfile.dreNumber">DRE License Number: {{ brokerUserProfile.dreNumber }}</div>
          <div>Email: <a :href="'mailto:' + brokerUserProfile.email">{{ brokerUserProfile.email }}</a></div><br/>
          <div v-if="brokerUserProfile.phone">Cell Phone Number: {{ brokerUserProfile.phone }}</div>
          <div v-if="brokerUserProfile.officePhone">Office Phone Number: {{ brokerUserProfile.officePhone }}</div>
          <!--
          <div v-if="brokerUserProfile.fax">Fax {{ brokerUserProfile.fax }}</div>
          -->
        </div>
        <!-- <div class="brokerLogo"><img :src="tenantLogoUrl(tenantProfile)" /></div> -->
      </div>

    </div>
  </div>
</template>

<script>
  import VueMarkdown from 'vue-markdown'
  import InlineSpinner from './elements/InlineSpinner.vue'
  import { tenantLogoUrl } from '../utils/PfxUtils.js'

  export default {
    name: 'AuctionBrokerInfoWidget',
    components: {
      VueMarkdown,
      InlineSpinner
    },
    props: {
      initialAuction: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        loading1: 0,
        loading2: 0,
        // tenantProfile: {},
        brokerUserProfile: {},
        delegatedAgentProfiles: []
      }
    },
    computed: {
      brokerPhoto() {
        return this.brokerUserProfile.photoUrl || require('../assets/placeholder-user.png')
      },
      systemPhoto() {
        return '../assets/placeholder-user.png'
      }
    },
    created() {
    this.loading1++
      const auctionId = this.initialAuction.id
      this.$PfxBackendApi.getAuctionDelegatedAgents(auctionId).then(res => {
        if (res.data) {
          this.delegatedAgentProfiles = this.brokerUserProfile
          console.info('getAuctionDelegatedAgents res:', res) // res.data = { id, email, firstName, lastName, phone, photoUrl }
          this.delegatedAgentProfiles = res.data
        }
      }).catch(err => {
        console.error('getAuctionDelegatedAgents error:', err)
      }).then(() => this.loading1--)

      this.loading2++
      const agentId = this.initialAuction.listingAgent
      this.$PfxBackendApi.getUser(agentId).then(res => {
        if (res.data.id) {
          console.info('AuctionBrokerInfoWidget: getUser res', res) // res.data = { id, email, firstName, lastName, phone, photoUrl }
          this.brokerUserProfile = res.data
        }
      }).catch(err => {
        console.error('AuctionBrokerInfoWidget: getUser error', err)
      }).then(() => this.loading2--)
    },
    methods: {
      tenantLogoUrl
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .brokerContainer {
    @include clearfix();
    display: inline-block;
    width: 100%;
    position: relative;
  }
  .brokerPhoto {
    @include column(2/10);
    img {
      width: 60%;
    }
  }
  .brokerInfo {
    @include column(6/10);
    text-align: left;
  }
  .brokerLogo {
    img {
      width: 2.5rem;
      position: absolute;
      top: 1rem;
      right: 1rem;
    }
  }
  .message {
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/AuctionBrokerInfoWidget.vue